export const TEAM_MEMBER_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
};
